export default __webpack_public_path__ + "static/media/mc_5.d1362e89.png";